module.exports = __webpack_public_path__ + "7aa7c2ad7df9a222e355032a5e8a48eb.png";